import { render, staticRenderFns } from "./BookingTimelineCard.vue?vue&type=template&id=42e31064&scoped=true"
var script = {}
import style0 from "./BookingTimelineCard.vue?vue&type=style&index=0&id=42e31064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e31064",
  null
  
)

export default component.exports